import { FC } from 'react';

import { FormControl, FormControlBaseProps } from '../FormControl';

import { FormPlainValidation, FormPlainVariant } from './FormPlain.types';
import { FormPlainInput } from './FormPlainInput/FormPlainInput';

import styles from './FormPlain.module.scss';

interface FormPlainProps extends FormControlBaseProps<FormPlainValidation> {
  variant: FormPlainVariant;
  placeholder?: string;
}

export const FormPlain: FC<FormPlainProps> = ({
  variant,
  autofocus,
  placeholder,
  ...props
}) => {
  return (
    <FormControl
      {...props}
      type="plain"
      variant="inline"
      className={styles.root}
    >
      {({ onBlur, onChange, value = '' }) => {
        return (
          <FormPlainInput
            value={value}
            onBlur={onBlur}
            variant={variant}
            onChange={onChange}
            autofocus={autofocus}
            placeholder={placeholder}
          />
        );
      }}
    </FormControl>
  );
};
